import { Search } from "lucide-react";

export const ChatInput = ({ value, onChange, onSubmit, disabled, inputRef }) => {
    const handleKeyDown = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            onSubmit();
        }
    };

    return (
        <div className="flex items-center gap-2.5 p-4 border-t border-cm-p-outline">
            <input
                ref={inputRef}
                type="text"
                className="flex-1 h-10 px-3 py-2 bg-cm-p-surface-container border border-cm-p-outline rounded-md text-sm text-cm-p-text-primary placeholder:text-cm-p-text-secondary focus:outline-none focus:ring-0"
                placeholder="Ask a question"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={handleKeyDown}
            />
            <button
                type="button"
                className="flex items-center justify-center h-10 w-10 shrink-0 rounded-md bg-cm-p-accent-400 text-cm-p-neutral-dark-500 disabled:opacity-50"
                onClick={onSubmit}
                disabled={disabled}
                aria-label="Send message"
            >
                <Search size={16} />
            </button>
        </div>
    );
};
